/**
 * «Сбросить баланс» (демо): баланс становится стартовым — недостающее начисляется, излишек списывается.
 * Один компонент для игрока (профиль) и администратора (профиль пользователя и список пользователей).
 */
import { useState } from 'react';
import type { ProfileDetails } from '@mt/protocol';
import { t } from '../../i18n';
import { cr } from '../../lib/format';
import { client, useApp } from '../../net/client';
import { Dialog } from '../Dialog';

export function ResetBalanceButton(props: { name: string | null; balance: number; reset: () => Promise<ProfileDetails>; onDone?: (p: ProfileDetails) => void; className?: string }) {
  const info = useApp((s) => s.info);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const start = info?.startingBalance ?? 0;
  const run = async () => {
    setOpen(false);
    setBusy(true);
    try {
      const p = await props.reset();
      props.onDone?.(p);
      client.toast('info', t('profile.reset.done', { amount: p.balance }));
    } catch (e) {
      client.toast('error', (e as Error).message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <button className={`btn tiny ${props.className ?? ''}`} disabled={busy || !info || props.balance === start} title={props.balance === start ? t('profile.reset.already') : undefined} onClick={() => setOpen(true)}>
        {t('profile.reset.button')}
      </button>
      {open && (
        <Dialog title={props.name ? t('profile.reset.titleFor', { name: props.name }) : t('profile.reset.title')} confirmText={t('profile.reset.confirm', { amount: start })} onClose={() => setOpen(false)} onConfirm={() => void run()}>
          <p>
            {t('profile.reset.textBefore')} <b className="mono">{cr(start)}</b> {t('profile.reset.textNow')} <span className="mono">{cr(props.balance)}</span>
            {t('profile.reset.textAfter')}
          </p>
        </Dialog>
      )}
    </>
  );
}
